import {
    CoachingCardRep,
    MyCoachingCard,
    OpportunityAlignment,
    PillarThree,
    PillarTwo,
} from './action';
import { ActionsType } from './actions.model';

export const actions: ActionsType = {
    CoachingCardRep,
    MyCoachingCard,
    OpportunityAlignment,
    PillarThree,
    PillarTwo,
};
